import { useNavigate } from 'react-router-dom'
import { useTheme } from '../ThemeContext'
import { useEffect, useState } from 'react'
import { apiURL } from '../utilities/URLs'
import { affiliateData, Payment } from '../data/AffiliateData'
import { refreshAccessToken } from '../utilities/extensions'

export default function Payments() {
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()

  const [payments, setPayments] = useState([])
  const [fetchingPayments, setFetchingPayments] = useState(true)

  useEffect(() => {
    const handleGetPayments = async () => {
      setFetchingPayments(true)
      const paymentsResponse = await fetch(`${apiURL}/api/getPayments?affiliateId=${encodeURIComponent(affiliateData.account.accountId)}`, {
        headers: {
          'Authorization': affiliateData.accessToken
        }
      })
      const paymentsData = await paymentsResponse.json()
      setFetchingPayments(false)
      if(paymentsData.response.error) {
        if(paymentsData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetPayments() : navigate('/affiliate', { state: { expired: true } })
        } else
          console.error(paymentsData.response.error)
      } else
        setPayments(paymentsData.response.payments)
    }

    handleGetPayments()
  }, [])

  const handleDownloadURL = async (link) => {
    const response = await fetch(`${apiURL}/api/generates3URL?url=${encodeURIComponent(link)}`, {
      headers: {
        Authorization: affiliateData.accessToken,
      },
    })
    const data = await response.json()
    if(data.response.error) {
      if(data.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleDownloadURL(link) : navigate('/affiliate', { state: { expired: true } })
      } else
        console.error(data.response.error)
    } else
      return window.innerWidth <= 768 ? window.location.href = data.response.s3Url : window.open(data.response.s3Url, '_blank')
  }

  return (
    <div className='w-screen flex flex-col items-center font-mont p-10'>
  <p className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
    Payments
  </p>

  {fetchingPayments ? (
    <div className='flex flex-row items-center justify-center gap-2 mt-5 w-full col-span-2'>
      <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8'></div>
      <p className={`text-md text-center ${isDarkMode && 'text-white'}`}>Fetching Payments...</p>
    </div>
  ) : payments.length > 0 ? (
    <div className='w-full max-w-md mt-6 space-y-4'>
      {payments.map((_payment, index) => {
        const payment = new Payment(_payment)
        return (
          <div 
            key={index} 
            className={`p-5 rounded-xl shadow-lg ${isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}`}
          >
            <div className='flex justify-between text-sm text-gray-500'>
              <span>Date</span>
              <span className={`font-semibold ${isDarkMode && 'text-white'}`}>
                {payment.paymentDate}
              </span>
            </div>
            <div className='flex justify-between mt-1 text-sm text-gray-500'>
              <span>Amount</span>
              <span className={`font-semibold ${isDarkMode && 'text-white'}`}>
                ${payment.paymentAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
            <button onClick={() => handleDownloadURL(payment.linkURL)} className='w-full py-2 bg-primaryColor hover:bg-primaryDarkColor duration-200 rounded-md mt-4 text-white'>
              Download CSV
            </button>
          </div>
        )
      })}
    </div>
  ) : (
    <p className={`text-lg mt-6 ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
      No Payments.
    </p>
  )}
</div>

  )
}